/**
 * Formats a date-only value (YYYY-MM-DD) in the local locale without a
 * timezone shift. Returns a dash when empty.
 * @function formatDateOnly
 * @since 1.0.0
 */
export function formatDateOnly(value) {
    if (!value) {
        return '—';
    }
    const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value);
    if (!match) {
        return new Date(value).toLocaleDateString();
    }
    return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3])).toLocaleDateString();
}
